import React, { useEffect, useState } from 'react';
import BrandedMissionName, { MISSION_NAME_TITLE } from '../common/BrandedMissionName';
import homeHero1 from '../../assets/t1.jpg';
import homeHero2 from '../../assets/t2.jpg';
import homeHero3 from '../../assets/t3.jpg';

const heroImages = [homeHero1, homeHero2, homeHero3];
const heroSubtitle = "Recognition of Women's Courage";

const HomeHero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const totalSlides = heroImages.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
    }, 4000);

    return () => clearInterval(interval);
  }, [totalSlides]);

  const goToNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
  };

  const goToPreviousSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? totalSlides - 1 : prevSlide - 1
    );
  };

  const handleTouchStart = (event) => {
    setTouchStartX(event.touches[0].clientX);
  };

  const handleTouchEnd = (event) => {
    if (touchStartX === null) {
      return;
    }

    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartX - touchEndX;
    const swipeThreshold = 50;

    if (swipeDistance > swipeThreshold) {
      goToNextSlide();
    } else if (swipeDistance < -swipeThreshold) {
      goToPreviousSlide();
    }

    setTouchStartX(null);
  };

  return (
    <section
      className="relative h-[100vh] min-h-[480px] w-full overflow-hidden"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {heroImages.map((image, index) => (
        <div
          key={`hero-image-${index}`}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={image}
            alt={`Welcome to ${MISSION_NAME_TITLE}`}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-black/45" />
        </div>
      ))}

      <div className="relative z-10 flex h-full items-center justify-center px-6 md:px-12">
        <div className="max-w-3xl text-center text-white">
          <h1 className="mb-4 text-2xl font-bold leading-snug sm:text-3xl md:text-5xl">
            <span className="block">Welcome to</span>
            <span className="mt-2 block break-words">
              <BrandedMissionName includeMissionSuffix={true} />
            </span>
           
          </h1>
          <p className="text-lg font-medium text-white/95 md:text-2xl">
            {heroSubtitle}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={goToPreviousSlide}
        className="absolute left-4 top-1/2 z-10 hidden -translate-y-1/2 rounded-full bg-black/35 px-3 py-2 text-xl text-white transition hover:bg-black/55 md:block"
        aria-label="Previous slide"
      >
        &#8249;
      </button>

      <button
        type="button"
        onClick={goToNextSlide}
        className="absolute right-4 top-1/2 z-10 hidden -translate-y-1/2 rounded-full bg-black/35 px-3 py-2 text-xl text-white transition hover:bg-black/55 md:block"
        aria-label="Next slide"
      >
        &#8250;
      </button>

      <div className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 gap-3">
        {heroImages.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setCurrentSlide(index)}
            className={`h-2.5 rounded-full transition-all ${
              index === currentSlide ? 'w-8 bg-white' : 'w-2.5 bg-white/45'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HomeHero;
